// Every Nexus/floor timestamp renders in America/Chicago unless a caller pins another zone.
const TZ = "America/Chicago";
const withTz = (o) => (o && o.timeZone ? o : { ...(o || {}), timeZone: TZ });
["toLocaleString", "toLocaleDateString", "toLocaleTimeString"].forEach((fn) => {
  const orig = Date.prototype[fn];
  Date.prototype[fn] = function (locales, opts) { return orig.call(this, locales, withTz(opts)); };
});

const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// lightweight-charts tick labels: chart times are UTC dates, so format them in UTC (not CT).
export const utcTickFormatter = (t, type) => {
  const d = typeof t === "object" ? new Date(Date.UTC(t.year, t.month - 1, t.day)) : new Date((typeof t === "string" ? Date.parse(t) / 1000 : t) * 1000);
  if (type === 0) return String(d.getUTCFullYear());
  if (type === 1) return MON[d.getUTCMonth()];
  if (type === 2) return String(d.getUTCDate());
  return `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
};
